
import { defineComponent, PropType } from 'vue'
import IssueDetailMixin from '~/mixins/issueDetailMixin'
import ActiveUserMixin from '~/mixins/activeUserMixin'
import { IgnoreCheckIssueActionChoice } from '~/types/types'

export default defineComponent({
  name: 'IgnoreIssueIntentional',
  mixins: [IssueDetailMixin, ActiveUserMixin],
  emits: ['close', 'ignore'],
  props: {
    ignoreActionType: {
      type: String as PropType<IgnoreCheckIssueActionChoice>,
      required: true
    },
    checkIssueId: {
      type: String,
      required: true
    },
    isOpen: {
      type: Boolean,
      required: true
    },
    shortcode: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      isLoading: false
    }
  },
  computed: {
    issueShortcode(): string {
      return this.shortcode ?? this.issue.shortcode ?? this.singleIssue.shortcode
    }
  },
  methods: {
    close(): void {
      this.$emit('close')
    },
    async confirm(): Promise<void> {
      this.isLoading = true
      try {
        const response = await this.updateIgnoreCheckIssue({
          checkIssueId: this.checkIssueId,
          action: this.ignoreActionType
        })
        if (response.ok) {
          this.$toast.success(`Ignored the current occurrence of ${this.issueShortcode}.`)

          this.$emit('ignore', [this.checkIssueId])
        } else {
          throw new Error('Received a non-ok response for this check')
        }
      } catch (e) {
        this.logErrorForUser(
          e as Error,
          'Ignore Issue',
          {
            method: 'Ignore issue intentional',
            shortcode: this.shortcode,
            checkIssueId: this.checkIssueId
          },
          'Something went wrong while ignoring this issue, please contact support.'
        )
      } finally {
        this.isLoading = false
      }
    }
  }
})
